import * as React from "react"
import styled from "styled-components"
import Input from "../components/Input"
import Label from "../components/Label"
import Textarea from "../components/Textarea"
import Layout from "../components/layout"
import FormGroup from "../components/FormGroup"
import SEO from "../components/seo"

const StyledForm = styled.form`
  border: 1px solid ${({ theme }) => theme.colors.grey1};
  border-radius: 5px;
  background-color: #fff;
  padding: 30px;
  max-width: 500px;
  margin: 0 auto 4rem;
  box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1);
`

export default () => (
  <Layout>
    <SEO title="Contact us" />
    <div className="container">
      <div className="heading">
        <h1>Contact us</h1>
        <h4 className="secondary">
          We are here to answer any of your questions
        </h4>
      </div>
      <StyledForm
        name="contact"
        method="post"
        data-netlify="true"
        data-netlify-honeypot="bot-field"
        action="/contact-thanks"
      >
        <input type="hidden" name="form-name" value="contact" />
        <input type="hidden" name="bot-field" />
        <FormGroup>
          <Label>Your name</Label>
          <Input type="text" name="name" id="name" required={true} />
        </FormGroup>
        <FormGroup>
          <Label>Your email</Label>
          <Input type="email" name="email" id="email" required={true} />
        </FormGroup>
        <FormGroup>
          <Label>Your message</Label>
          <Textarea name="message" id="message" required={true} />
        </FormGroup>
        <div className="text-center">
          <button className="btn" type="submit">
            Send message
          </button>
        </div>
      </StyledForm>
    </div>
  </Layout>
)
